module.exports = __webpack_public_path__ + "img/img1.71f015c9.png";